import { render, staticRenderFns } from "./BaseTLCheckBoxDesign.vue?vue&type=template&id=39e948fa&"
import script from "./BaseTLCheckBoxDesign.vue?vue&type=script&lang=ts&"
export * from "./BaseTLCheckBoxDesign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports